import { mount } from 'svelte'
import App from './components/App.svelte'
import { registerServiceWorker } from './register-service-worker'
import 'context-filter-polyfill'

registerServiceWorker()

const app = mount(App, {
  target: document.body
})

export default app